export default "__VITE_ASSET__2b4ac605__"